import React, { createContext, useContext, useState, useEffect } from "react";
import { CURRENCIES, TZ_TO_CURRENCY, formatQuote, upfrontDiscountRate } from "./data";

const CurrencyContext = createContext(null);

// Detect the visitor's local currency from their IANA timezone (no external API/key).
const detectCurrency = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TZ_TO_CURRENCY[tz]) return TZ_TO_CURRENCY[tz];
  } catch (e) {
    /* ignore — fall back to USD */
  }
  return "usd";
};

export function CurrencyProvider({ children }) {
  const [curId, setCurId] = useState(() => {
    const stored = localStorage.getItem("gesung_currency");
    if (stored && CURRENCIES.some((c) => c.id === stored)) return stored;
    return detectCurrency();
  });
  const [upfront, setUpfront] = useState(() => localStorage.getItem("gesung_upfront") === "1");
  const [financeMonths, setFinanceMonths] = useState(() => Number(localStorage.getItem("gesung_finance_months")) || 12);

  useEffect(() => {
    localStorage.setItem("gesung_currency", curId);
  }, [curId]);

  useEffect(() => {
    localStorage.setItem("gesung_upfront", upfront ? "1" : "0");
  }, [upfront]);

  useEffect(() => {
    localStorage.setItem("gesung_finance_months", String(financeMonths));
  }, [financeMonths]);

  const cur = CURRENCIES.find((c) => c.id === curId) || CURRENCIES[0];
  // Ghana keeps 5% off for upfront; every other market gets 25% off for outright cash.
  const UPFRONT_DISCOUNT = upfrontDiscountRate(curId);
  const applyDiscount = (usd) => (upfront ? usd * (1 - UPFRONT_DISCOUNT) : usd);
  const format = (usd) => formatQuote(usd, cur);

  return (
    <CurrencyContext.Provider
      value={{ cur, curId, setCurId, currencies: CURRENCIES, format, upfront, setUpfront, discountRate: UPFRONT_DISCOUNT, applyDiscount, financeMonths, setFinanceMonths }}
    >
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
